/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The CompanyDeptForm model module.
   * @module course_standard/model/CompanyDeptForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CompanyDeptForm</code>.
   * @alias module:course_standard/model/CompanyDeptForm
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>CompanyDeptForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/CompanyDeptForm} obj Optional instance to populate.
   * @return {module:course_standard/model/CompanyDeptForm} The populated <code>CompanyDeptForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'companyId')) {
        obj['companyId'] = ApiClient.convertToType(data['companyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'deptId')) {
        obj['deptId'] = ApiClient.convertToType(data['deptId'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 公司id
   * @member {Integer} companyId
   */
  exports.prototype['companyId'] = undefined;
  /**
   * 分院id
   * @member {Integer} deptId
   */
  exports.prototype['deptId'] = undefined;



  export default exports;
;


